module.exports = __webpack_public_path__ + "static/media/dropdown.96587174.svg";